import { Injectable } from '@angular/core';

/**
 * 状态码 → 颜色（来源：sunan-server 业务 *State/*Status 枚举全量去重）
 * 已排除：银行支付 / AGV / HTTP StatusCode
 * 颜色语义：
 * 黄-过程中/中间态；灰-初始未开始/线下停用类；红-作废拒绝失效；
 * 蓝-审核流转中；绿-完成启用生效；橙-部分完成/预警
 */
export const statusToColor = {
  // 黄色：过程中 / 中间态 / 待处理动作
  '#FAB13B': [
    'partshipped', 'partShipped', 'committed', 'COMMITTED', 'partValid', 'confirm', 'picking',
    'prepareSubmitted', 'prepareConfirmed', 'receiving', 'shipping', 'delivering', 'approving',
    'tendering', 'forPick', 'forPickup', 'forMove', 'forLoss', 'forMachiningTask', 'forReturn',
    'forTransfer', 'forWholesale', 'outTransit', 'unconfirmedPrice', 'reSubmitted', 'submit',
    'firstReview', 'Locked', 'beingUsed', 'transferLock', 'agvTransferLock', 'suspend',
    'collected', 'merged', 'planCared', 'toBeConfirm', 'toBePaid', 'UNRECEIVED',
    '开票中', '红冲开票中', '待生效', '对账中', '可付款', '可对账',
  ],
  // 灰色：初始 / 未开始 / 未提交 / 线下停用 / 未读未打印
  '#9FA4A2': [
    'initial', 'INITIAL', 'INIT', 'uncommitted', 'OFF_LINE', 'UN_PRINTED', 'unpublish', 'pastpublish',
    'TO_COMMIT', 'unpublished', 'UNPUBLISHED', '未审核', 'returned', 'saved', 'SAVED', 'unaudited',
    'UN_AUDIT', 'unlock', 'free', 'unKnow', 'noSign', 'NOT_INVOICED', 'notConfirm', 'unshipped',
    'unPlanCar', 'UNREAD', 'UNSEND', '未提交', '未确认', '已保存', '未对账', '未登记', '未付款',
  ],
  // 红色：删除 / 作废 / 拒绝 / 失效 / 禁用
  '#F5222D': [
    'delete', 'deleted', 'DELETED', 'abort', 'ABORTED', 'aborted', 'rejected', 'REJECTED',
    '停用', '禁用', '已停用', 'unpicked', 'AUDIT_REJECT', 'invalid', 'INVALID', 'disabled', 'DISABLED',
    '', 'canceled', 'cancelled', 'BLANK_OUT', 'complaintRejected', 'prepareRejected',
    'returnedBeforeAudit', 'RETURNED_BEFORE_AUDIT', 'returnedBeforeConfirm', 'handleReturned',
    'TAKE_DOWN', 'expired', 'paidFailed', 'submitFailed', 'exception',
    '已作废', '已删除', '已失效',
  ],
  // 蓝色：已审核 / 提交后流转 / 处理中
  '#3B77E3': [
    'audited', 'adjusted', 'invoiced', 'INVOICED', 'audit', 'submitted', 'SUBMITTED', 'TO_AUDIT',
    '已审核', '处理中', 'processing', 'firstReviewed', 'awaiting_effective', 'AWAITING_EFFECTIVE',
    'checking', 'reviewed', 'running', 'SENT', 'uploaded', 'snapped', 'handling',
    '已提交', '已初审', '已复审', '已分配', '已生成费用单',
  ],
  // 绿色：完成 / 成功 / 启用 / 生效
  '#20B95D': [
    'shipped', 'SHIPPED', 'received', 'RECEIVED', 'checked', 'using', 'USING', 'reverse', 'valid',
    'approved', 'ON_LINE', 'finished', 'FINISHED', 'finish', 'opened', 'PRINTED', '启用', 'picked',
    'published', 'PUBLISHED', 'AUDITED', '已收票', '付款完成', '收款完成', '已收款', 'accepted',
    'offered', 'confirmed', 'effective', 'EFFECTIVE', '已发布', 'paid', 'successful', 'READ',
    'signed', 'ON_SALE', 'enabled', 'entrucked', 'normal', 'statemented',
    '已付款', '已核销', '已开票', '已完成', '已确认', '已红冲', '已结束', '已发货', '已收货', '生效中',
    '已对账', '已登记',
  ],
  // 橙色：部分完成 / 打印后修改 / 临期预警
  '#F05B24': [
    'partialReceived', 'partDelete', 'tender', 'MODIFIED_AFTER_PRINTED', '部分付款', '部分收款',
    'partPublished', 'partOffered', 'partInvoiced', 'partStatemented', '部分核销', 'willExpired',
    'supplierConfirmed',
  ],
};

@Injectable({
  providedIn: 'root'
})
export class HdStatusService {
  constructor() {
  }
}
